<template>
  <div class="join-page">
    <div class="toolbar">
      <el-button size="small" class="btn btn-back" icon="el-icon-arrow-left" @click="doBack" round>返回</el-button>
      <el-button size="small" class="btn btn-close" icon="el-icon-close" @click="doClose" circle></el-button>
    </div>
    <div class="content">
      <h1 class="home-title">选择企业</h1>
      <p class="home-description">我们将在企业中为您提供优质服务</p>
      <hr>
      <ul class="org-group">
        <!--
        <li class="org-item">
          <img class="org-item-img" src="https://dn-st.teambition.net/teambition/images/logo0.2bacc028.jpg" alt="">
          <div class="org-item-content">
            <div class="org-item-name">四川正汇通企业咨询管理有限公司</div>
          </div>
          <i class="el-icon-arrow-right"></i>
        </li>
        -->
        <li class="org-item" v-for="comp in companyList" :key="comp.id" @click="toDashboard(comp)">
          <img class="org-item-img" src="https://dn-st.teambition.net/teambition/images/logo0.2bacc028.jpg" alt="">
          <div class="org-item-content">
            <div class="org-item-name">{{ comp.name }}</div>
            <div class="org-item-desc margin-top-5">
              <el-tag effect="plain" size="mini" type="warning" v-if="comp.status===0">审核中</el-tag>
              <el-tag effect="plain" size="mini" type="danger" v-if="comp.status===2">审核不通过</el-tag>
            </div>
          </div>
          <i class="el-icon-arrow-right" v-if="comp.status === 1"></i>
        </li>
        <li class="org-item org-item-create" @click="toRegister" v-if="false">
          <div class="org-item-img"><i class="el-icon-plus"></i></div>
          <div class="org-item-content">
            <div class="org-item-name">创建新的企业</div>
            <div class="org-item-desc">可用于企业、组织或团队</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { fetchList } from '@/api/enterprise/enterprise'
import { mapGetters } from 'vuex'
export default {
  name: 'page',
  data() {
    return {
      info: {},
      companyList:[]
    }
  },
  computed: {
    ...mapGetters(['company'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(){
      fetchList().then(res => {
        console.log(res)
        this.companyList = res.data.result
      })
    },
    toDashboard(comp) {
      if(comp.status === 1){
        this.$store.dispatch('user/switchCompany',comp).then(()=>{
          this.$router.replace('/')
        })
      }
    },
    doBack(){
      this.doClose()
    },
    doClose(){
      if(!this.company){
        this.$store.dispatch('user/logout').then(()=>{
          this.$router.replace('/login')
        })
      }else{
        this.$router.go(-1)
      }
    },
    toRegister() {
      this.$router.push('/create/company')
    }

  }
}
</script>

<style lang="scss">
.join-page {
  height: 100vh;
  width: 100%;
  font-family:-apple-system,Noto Sans,Helvetica Neue,Helvetica,Nimbus Sans L,Arial,Liberation Sans,PingFang SC,Hiragino Sans GB,Noto Sans CJK SC,Source Han Sans SC,Source Han Sans CN,Microsoft YaHei,Wenquanyi Micro Hei,WenQuanYi Zen Hei,ST Heiti,SimHei,WenQuanYi Zen Hei Sharp,sans-serif;

  .toolbar{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 50px;

    .btn{
      color: #595959;
      background: #e5e5e5;
      border:none;
      &:hover{
        border:none;
        color: #262626;
        background: #d9d9d9;
      }
    }
  }
  .content{
    background-color: #fff;
    width:500px;
    margin: 50px auto 20px;
    min-height: 460px;
    border:1px solid #ccc;
    border-radius: 6px;


    .home-title{
      font-size: 36px;
      font-weight: 400;
      margin:10px 0;
    }

    .home-description{
      margin:10px 0 10px;
      line-height: 24px;
      height: 24px;
      font-size: 18px;
      color: #8c8c8c;
      box-sizing: border-box;
      text-rendering: optimizeLegibility;
      font-weight: lighter;
    }

    hr{
      border: solid #e5e5e5;
      border-width: 1px 0 0 0;
      margin-bottom:24px;
      background: #f0f0f0;
    }

    .org-group{
      list-style: none;

      .org-item{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;

        .org-item-img{
          width:40px;
          height:40px;
          border-radius: 4px;
          margin-right: 15px;
        }

        .org-item-content{
          .org-item-name{
            &:hover{
              color: #00a0e9;
            }

            width:395px;
            font-size: 14px;
            flex: 0 1 auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .org-item-desc{
            color: #bfbfbf;
            font-size: 12px;
            line-height: 12px
          }
        }

      }

      .org-item-create{
        .org-item-name{
          line-height: 20px;
          color: #8c8c8c;
          margin-bottom: 4px
        }
        .org-item-img{
          text-align: center;
          line-height: 40px;
          background-color: #f0f0f0;
        }

      }
    }
  }
}
</style>
